/* eslint-disable no-restricted-globals */

import { ContentItemTypes } from 'modules/Boards/Types';
import LoginRedirect from '../critical/loginRedirection';
import { createElement, query } from '../modules';
import AddToMyBoards from '../components/addToMyBoards';
import { utility } from '../modules/utility';

const filtersContainer = document.getElementById('active-filters-container');
const suggestionsContainer = document.getElementById('suggestions-container');
const searchBar = document.getElementById('search-bar');
const searchBarForm = document.getElementById('search-bar-form');
const sortDropdownElement = document.getElementById('sort-by-select');
const filtersCollapseBtn = document.getElementById('filters-collapse-btn');

const { FormatText } = ShawContract;

const QUERY_SEARCH_BAR_KEY = 'search';
const QUERY_SORT_KEY = 'sort';
const DEFAULT_SORT_TYPE = 'date desc';

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}


const Page = {
  state: {
    filters: {},
    activeFilters: {},
    sortBy: null,
    searchTerm: '',
    searchResults: [],
    hasSuggestions: false,
  },

  getState(prop) {
    return this.state[prop] !== undefined ? this.state[prop] : this.state;
  },

  setState(newState) {
    this.state = { ...this.state, ...newState };
    return this.state;
  },

  generateFiltersDataStructure() {
    const filtersElements = document.querySelectorAll('.filter-input');
    const filters = {};
    for (let i = 0; i < filtersElements.length; i++) {
      const filterElement = filtersElements[i];
      const filterName = filterElement.getAttribute('data-label');
      const filterType = filterElement.getAttribute('data-filter-type');
      const inputType = filterElement.getAttribute('data-type');
      const filterValue = filterElement.getAttribute('data-value');

      const newFilter = new Filter({
        filterName,
        filterType,
        filterElement,
        inputType,
        filterValue,
      });

      filters[filterType] = filters[filterType] || {};
      filters[filterType][filterValue] = newFilter;

      this.setState({
        filters,
      });
    }
  },

  setStateFromUrl(shouldRender) {
    Page.clearAllFilters(false);
    // fetch the query strings
    const queryStrings = query.getQueryStrings();
    const { filters } = Page.state;

    // map query strings to page state
    const searchTerm = queryStrings[QUERY_SEARCH_BAR_KEY] && queryStrings[QUERY_SEARCH_BAR_KEY][0];
    const sortType = queryStrings[QUERY_SORT_KEY] && queryStrings[QUERY_SORT_KEY][0];


    Object.keys(queryStrings).forEach((type) => {
      if (filters[type]) {
        queryStrings[type].forEach((value) => {
          Page.addFilter(type, value);
        });
      }
    });

    if (searchTerm) {
      searchBar.value = searchTerm;
    } else {
      Page.searchBar.resetSearchBar();
    }

    if (sortType) {
      $(sortDropdownElement).selectpicker('val', sortType);
      Page.sortBy(sortType);
    } else {
      $(sortDropdownElement).selectpicker('val', DEFAULT_SORT_TYPE);
      Page.sortBy(DEFAULT_SORT_TYPE);
    }

    if (searchTerm || sortType || Page.hasActiveFilters() || shouldRender) {
      Page.applyFilters();
      Page.filterByKeyword(searchTerm);
      Page.renderCollections(true);
    }
  },

  setQueryStrings() {
    const { activeFilters, searchTerm } = Page.state;
    const sortType = sortDropdownElement.value;
    const qs = {};

    Object.keys(activeFilters).forEach((type) => {
      Object.values(activeFilters[type]).forEach((filter) => {
        if (qs[type]) {
          qs[type].push(filter.getValue());
        } else {
          qs[type] = [filter.getValue()];
        }
      });
    });

    if (searchTerm) {
      Object.assign(qs, { search: searchTerm });
    }

    if (sortType !== DEFAULT_SORT_TYPE) {
      Object.assign(qs, { sort: sortType });
    }

    query.setQueryStrings(qs);
    LoginRedirect.changeLoginRedirect();
  },

  addFilter(filterType, filterValue) {
    const { activeFilters } = Page.state;
    const { filters } = Page.state;

    const filter = filters[filterType][filterValue];
    filter.createActiveFilterElement();
    filter.selectFilter();

    activeFilters[filterType] = activeFilters[filterType] || {};
    activeFilters[filterType][filterValue] = filter;

    this.setState({
      activeFilters,
    });
    return activeFilters;
  },

  removeFilter(type, key) {
    const { activeFilters } = this.state;
    const filter = activeFilters[type][key];

    filter.removeActiveFilterElement();
    filter.deselectFilter();
    delete activeFilters[type][key];

    if (Object.keys(activeFilters[type]).length === 0) {
      delete activeFilters[type];
    }

    this.setState({
      activeFilters,
    });

    return activeFilters;
  },

  clearAllFilters(shouldRender) {
    const { activeFilters } = Page.state;

    Object.values(activeFilters).forEach((type) => {
      Object.values(type).forEach((filter) => {
        filter.removeActiveFilterElement();
        filter.deselectFilter();
      });
    });

    Page.setState({
      activeFilters: {},
      filteredCollections: Page.state.collections,
    });
    Page.searchBar.resetSearchBar();

    if (shouldRender) {
      Page.renderCollections();
    }
  },

  isFilterAlreadyAdded(type, key) {
    const { activeFilters } = this.state;
    return activeFilters[type] && activeFilters[type].hasOwnProperty(key);
  },

  hasActiveFilters() {
    return !!Object.keys(this.state.activeFilters).length;
  },

  onFilterClick(event) {
    const filterElement = event.currentTarget;
    const filterType = filterElement.getAttribute('data-filter-type');
    const filterValue = filterElement.getAttribute('data-value');
    const searchTerm = Page.getState('searchTerm');

    if (Page.isFilterAlreadyAdded(filterType, filterValue)) {
      Page.removeFilter(filterType, filterValue);
    } else {
      Page.addFilter(filterType, filterValue);
    }

    Page.applyFilters();
    Page.filterByKeyword(searchTerm);
    Page.renderCollections();
  },

  sortBy(type) {
    switch (type) {
      case 'date desc': {
        Compare.sort(Compare.dateDesc);
        break;
      }
      case 'alphabetic': {
        Compare.sort(Compare.alphabetic);
        break;
      }
      default: {
        // eslint-disable-next-line no-console
        console.warn('Unhandled sort type: ', type);
        break;
      }
    }
  },

  checkFilters(collection) {
    const { activeFilters } = Page.state;
    const filterTypes = Object.keys(activeFilters);
    let matchCount = 0;

    for (let j = 0; j < filterTypes.length; j++) {
      const type = filterTypes[j];
      const filters = Object.keys(activeFilters[type]);

      for (let i = 0; i < filters.length; i++) {
        const key = filters[i];
        const filter = activeFilters[type][key];
        const valueToCheck = filter.getValue();

        if (type === 'Type') {
          const customPatternString = 'Custom Pattern';
          const isCustomPatternFilterSelected = filters.some((value) => value === customPatternString);
          const hasCustomPattern = collection.state.ProductGroups.some((group) => group.ProductType === customPatternString);
          const hasOnlyCustomPattern = collection.state.ProductGroups.length === 1 && hasCustomPattern;

          if (isCustomPatternFilterSelected) {
            if (hasOnlyCustomPattern && filters.length === 1) {
              matchCount++;
              break;
            } else if (hasCustomPattern && !hasOnlyCustomPattern && filters.length !== 1) {
              matchCount++;
              break;
            }
          } else if (valueToCheck === collection.state.Type) {
            matchCount++;
            break;
          }
        }
      }

      if (type === 'ProductType') {
        const matchesProductTypes = filters.every((productType) => collection
          .getProductTypes()
          .some((prodType) => prodType === productType));
        if (matchesProductTypes) {
          matchCount++;
        }
      }
    }

    if (matchCount === filterTypes.length) {
      return true;
    }

    return false;
  },

  applyFilters() {
    let filteredCollections = this.state.collections;

    if (this.hasActiveFilters) {
      filteredCollections = filteredCollections.filter(this.checkFilters);
    }

    this.setState({
      filteredCollections,
    });
    return filteredCollections;
  },

  filterByKeyword(searchTerm) {
    if (searchTerm === undefined) {
      return;
    }

    const lowerCaseSearchTerm = searchTerm.trim().toLowerCase();
    const { filteredCollections } = this.state;
    const searchResults = [];

    filteredCollections.forEach((collection) => {
      const { searchProps } = collection.state;

      const isMatch = searchProps.some((prop) => prop
        .trim()
        .toLowerCase()
        .indexOf(lowerCaseSearchTerm) !== -1);

      if (isMatch) {
        searchResults.push(collection);
      }
    });

    this.setState({
      searchResults,
      searchTerm,
    });
  },

  renderCollections(dontSetQueryStrings) {
    const collectionsContainer = document.getElementById('collections-container');
    const collections = this.state.searchTerm
      ? this.state.searchResults : this.state.filteredCollections;
    const documentFragment = document.createDocumentFragment();

    utility.removeChildren(collectionsContainer);

    collections.forEach((collection) => {
      documentFragment.appendChild(collection.createProductCard());
    });

    collectionsContainer.appendChild(documentFragment);
    Page.addCarouselListeners();
    Page.searchBar.updatePlaceholder();
    if (!dontSetQueryStrings) {
      Page.setQueryStrings();
    }
    ShawContract.lazyLoadImages();
  },

  addCarouselListeners() {
    const carousels = document.querySelectorAll('.collection-card .carousel');

    for (let i = 0; i < carousels.length; i++) {
      const carousel = carousels[i];
      const defaultInterval = 1800;
      const interval = carousel.getAttribute('data-interval') || defaultInterval;
      let intervalId = null;

      $(carousel).carousel({
        interval: false,
      });

      $(carousel).on('mouseover', function () {
        const self = $(this);
        self.carousel('next');
        intervalId = setInterval(() => {
          self.carousel('next');
        }, interval);
      })
        .on('mouseout', function () {
          clearInterval(intervalId);
          $(this).carousel(0);
        });
    }
  },

  searchBar: {
    placeholder: ShawContract.i18n.FilterResultsLabel || 'Filter these 000 results by keyword',
    firstHalfOfSearchBarPlacecholder: '',
    secondHalfOfsearchBarPlaceholder: '',

    updatePlaceholder() {
      const resultsCount = Page.state.filteredCollections.length;
      searchBar.placeholder = this.firstHalfOfSearchBarPlacecholder
        + resultsCount + this.secondHalfOfsearchBarPlaceholder;
    },

    resetSearchBar() {
      searchBar.value = '';
      Page.searchBar.updatePlaceholder();

      Page.setState({
        searchTerm: '',
      });
    },

    i18nPlaceholder() {
      let isNumberFound = false;
      const strings = this.placeholder.split(' ');

      for (let i = 0; i < strings.length; i++) {
        const s = strings[i];
        const isNumber = parseInt(s);

        if (!isNaN(isNumber)) {
          isNumberFound = true;
          this.firstHalfOfSearchBarPlacecholder += ' ';
        } else if (!isNumberFound) {
          this.firstHalfOfSearchBarPlacecholder += ` ${s}`;
        } else {
          this.secondHalfOfsearchBarPlaceholder += ` ${s}`;
        }
      }
    },

    searchForSuggestions() {
      const searchTerm = searchBar.value.trim().toLowerCase();
      const { filteredCollections } = Page.state;
      const limit = 5;
      let count = 0;
      const suggestions = {};

      if (!searchTerm) {
        return undefined;
      }

      for (let i = 0; i < filteredCollections.length; i++) {
        const collection = filteredCollections[i];
        const propertiesToCheck = collection.state.searchProps;

        for (let j = 0; j < propertiesToCheck.length; j++) {
          const prop = propertiesToCheck[j];
          const string = prop.trim().toLowerCase();
          const indexFound = string.indexOf(searchTerm);

          if (indexFound !== -1 && !Object.prototype.hasOwnProperty.call(suggestions, prop)) {
            const suggestion = this.createSuggestionElement(prop, indexFound, searchTerm);
            suggestions[prop] = suggestion;
            count++;
            if (count === limit) {
              return count;
            }
          }
        }
      }
      return count;
    },

    createSuggestionElement(string, searchTermStartIndex, searchTerm) {
      const searchTermEndIndex = searchTermStartIndex + searchTerm.length;
      const beforeSearchTerm = string.slice(0, searchTermStartIndex);
      const matchingSearchTerm = string.slice(searchTermStartIndex, searchTermEndIndex);
      const afterSearchTerm = string.slice(searchTermEndIndex);

      const div = createElement({
        classes: 'suggestion-item',
        attributes: { tabindex: 0 },
      });

      const beforeSearchSpan = createElement({
        element: 'span',
        text: beforeSearchTerm,
      });

      const searchSpan = createElement({
        element: 'span',
        classes: 'blue-regular',
        text: matchingSearchTerm,
      });

      const afterSearchSpan = createElement({
        element: 'span',
        text: afterSearchTerm,
      });

      div.appendChild(beforeSearchSpan);
      div.appendChild(searchSpan);
      div.appendChild(afterSearchSpan);

      div.addEventListener('click', Page.searchBar.onSuggestionClick);
      div.addEventListener('keydown', (e) => {
        // eslint-disable-next-line no-restricted-globals
        if (event.keyCode === 13 || event.which === 13) {
          Page.searchBar.onSuggestionClick(e);
          utility.hideElement(suggestionsContainer);
        }
      });
      suggestionsContainer.appendChild(div);
    },

    onFocus() {
      if (Page.state.hasSuggestions
        && searchBar.value.trim().toLowerCase() !== Page.state.searchTerm) {
        utility.showElement(suggestionsContainer);
      }
    },

    onBlur() {
      setTimeout(() => {
        const { activeElement } = document;
        const isActiveElementWithin = activeElement.className.indexOf('suggestion-item') !== -1;
        const isSearchBar = activeElement === searchBar;

        if (!isActiveElementWithin && !isSearchBar) {
          utility.hideElement(suggestionsContainer);
        }
      }, 0);
    },

    onSuggestionClick(e) {
      const newSearchTerm = e.currentTarget.textContent;
      searchBar.value = newSearchTerm;
      utility.hideElement(suggestionsContainer);

      if (newSearchTerm != Page.state.searchTerm) {
        Page.filterByKeyword(newSearchTerm);
        Page.renderCollections();
      }
    },

    onTyping() {
      utility.removeChildren(suggestionsContainer);

      const hasMinChars = searchBar.value.length > 0;
      const hasSuggestions = Page.searchBar.searchForSuggestions();


      if (hasSuggestions && hasMinChars) {
        utility.showElement(suggestionsContainer);
      } else {
        utility.hideElement(suggestionsContainer);
      }

      Page.setState({ hasSuggestions });
    },

    onSubmit(event) {
      event.preventDefault();
      searchBar.blur();
      const searchTerm = searchBar.value;

      if (searchTerm !== Page.state.searchTerm) {
        Page.filterByKeyword(searchTerm);
        Page.renderCollections();
      }
      return false;
    },
  },

  mobile: {
    openFilters() {
      utility.preventBodyScroll({
        bgClasses: 'light-blue',
        bodyClasses: 'show-filters',
      });
    },
  },

  onInit() {
    let collections = JSON.parse(document.getElementById('data').value);
    collections = collections.map((col) => new Collection(col));
    Page.setState({
      collections,
      filteredCollections: collections,
    });

    Page.generateFiltersDataStructure();
    Page.setStateFromUrl(true);
    Page.addCarouselListeners();

    Page.searchBar.i18nPlaceholder();
    Page.searchBar.updatePlaceholder();
    searchBar.addEventListener('focus', Page.searchBar.onFocus);
    searchBar.addEventListener('blur', Page.searchBar.onBlur);
    searchBar.addEventListener('keyup', utility.debounce(Page.searchBar.onTyping, 200));
    searchBarForm.addEventListener('submit', Page.searchBar.onSubmit);
    searchBarForm.addEventListener('focusout', Page.searchBar.onBlur);
    filtersCollapseBtn.addEventListener('click', utility.filtersCollapse);

    const filterInputs = document.querySelectorAll('.filter-input');
    for (let i = 0; i < filterInputs.length; i++) {
      filterInputs[i].addEventListener('click', Page.onFilterClick);
    }

    document.getElementById('clear-filters').addEventListener('click', () => {
      Page.clearAllFilters(true);
    });

    document.getElementById('sort-by-select').addEventListener('change', (event) => {
      const sortType = event.currentTarget.value;
      Page.sortBy(sortType);
      Page.renderCollections();
    });

    document.getElementById('mobile-filter-btn').addEventListener('click', Page.mobile.openFilters);


    window.addEventListener('popstate', () => {
      Page.setStateFromUrl(true);
    });
  },
};


function Filter(props) {
  const defaultProps = {
    filterName: '',
    filterElement: null,
    activeFilterElement: null,
    inputType: null,
    filterType: null,
    filterValue: '',
  };
  this.state = { ...defaultProps, ...props };
  return this;
}

Filter.prototype.getState = function getState(prop) {
  return this.state[prop] !== undefined ? this.state[prop] : this.state;
};

Filter.prototype.setState = function setState(newState) {
  this.state = { ...this.state, ...newState };
  return this.state;
};

Filter.prototype.getValue = function getValue() {
  return this.state.filterValue;
};

Filter.prototype.createActiveFilterElement = function createActiveFilterElement() {
  const { filterName, filterType, filterValue } = this.state;

  const onBtnClick = () => {
    Page.removeFilter(filterType, filterValue);
    Page.applyFilters();
    Page.filterByKeyword(Page.getState('searchTerm'));
    Page.renderCollections();
  };

  const el = createElement({
    classes: 'active-filter',
    children: [
      createElement({
        element: 'span',
        text: FormatText.capitalizeEveryWord(filterName),
      }),
      createElement({
        element: 'button',
        classes: 'btn text-size-small ml-3',
        eventListeners: { click: onBtnClick },
        children: [
          createElement({
            element: 'i',
            classes: 'fas fa-times font-weight-light',
            attributes: { 'aria-hidden': true },
          }),
        ],
      }),
    ],
  });

  const fragment = document.createDocumentFragment();
  fragment.appendChild(el);
  filtersContainer.appendChild(fragment);

  this.fadeInFilter();
  this.setState({ activeFilterElement: el });
};

Filter.prototype.fadeInFilter = function fadeInFilter() {
  setTimeout(() => {
    this.state.activeFilterElement.classList.add('animate');
  }, 0);
};

Filter.prototype.removeActiveFilterElement = function removeActiveFilterElement() {
  filtersContainer.removeChild(this.state.activeFilterElement);
};

Filter.prototype.selectFilter = function selectFilter() {
  const state = this.getState();
  const el = state.filterElement;
  const type = state.inputType;

  switch (type) {
    case 'checkbox': {
      el.checked = true;
      break;
    }
    case 'color-checkbox': {
      el.classList.add('active');
      el.setAttribute('aria-pressed', true);
      break;
    }
    default: {
      // eslint-disable-next-line no-console
      console.trace('unhandled type on element: ', el);
    }
  }
};

Filter.prototype.deselectFilter = function deselectFilter() {
  const state = this.getState();
  const el = state.filterElement;
  const type = state.inputType;

  switch (type) {
    case 'checkbox': {
      el.checked = false;
      break;
    }
    case 'color-checkbox': {
      el.classList.remove('active');
      el.setAttribute('aria-pressed', false);
      break;
    }
    default: {
      // eslint-disable-next-line no-console
      console.trace('Unhandled type on element: ', el);
      break;
    }
  }
};


function Collection(props) {
  const defaultProps = {
    CollectionName: '',
    CollectionUrl: '',
    Images: [],
    ProductGroups: [],
    Type: '',
  };
  this.state = { ...defaultProps, ...props };

  const productGroups = props.ProductGroups;
  const searchProps = [];
  searchProps.push(props.CollectionName);

  productGroups.forEach((productGroup) => {
    productGroup.Products.forEach((product) => {
      Object.values(product).forEach((prop) => {
        if (typeof prop === 'string') {
          searchProps.push(prop);
        }
      });
    });
  });

  this.state.searchProps = searchProps;
  this.state.ProductGroups = productGroups.map((group) => {
    const ProductGroupLabel = group.Products && group.Products[0]
    && (group.Products[0].ProductTypeDesc || group.Products[0].ProductType);
    return { ...group, ProductGroupLabel };
  });
  return this;
}

Collection.prototype.getState = function getState(prop) {
  return this.state[prop] !== undefined ? this.state[prop] : this.state;
};

Collection.prototype.getName = function getName() {
  return this.state.CollectionName;
};

Collection.prototype.getType = function getType() {
  return this.state.Type;
};

Collection.prototype.getProducts = function getProducts() {
  return this.state.ProductGroups;
};

Collection.prototype.getProductTypes = function getProductTypes() {
  return this.state.ProductGroups.map((productGroup) => productGroup.ProductType);
};

Collection.prototype.setState = function setState(newState) {
  this.state = { ...this.state, ...newState };
  return this.state;
};

Collection.prototype.createProductCard = function createProductCard() {
  const state = this.getState();
  const name = state.CollectionName;
  const path = state.CollectionUrl;
  const images = state.Images;
  const productGroups = state.ProductGroups;

  const carouselID = `carousel${name}`;


  const card = createElement({
    classes: 'card collection-card',
  });

  const carousel = createElement({
    classes: 'carousel slide',
    attributes: {
      id: carouselID,
      'data-interval': '1800',
      'data-ride': 'false',
    },
  });
  card.appendChild(carousel);


  const carouselInner = createElement({
    classes: 'carousel-inner',
  });
  carousel.appendChild(carouselInner);

  const a = createElement({
    element: 'a',
    classes: 'stretched-link',
    attributes: { href: path },

  });
  carouselInner.appendChild(a);


  images.forEach((imageSrc, index) => {
    const carouselItem = createElement({
      classes: index === 0 ? 'carousel-item active' : 'carousel-item',
    });
    carouselInner.appendChild(carouselItem);

    const imageWrapper = createElement({
      classes: 'image-wrapper',
    });
    carouselItem.appendChild(imageWrapper);

    const img = createElement({
      element: 'img',
      classes: 'card-img',
      attributes: { 'data-src': imageSrc },
    });
    imageWrapper.appendChild(img);
  });


  const cardBody = createElement({
    classes: 'card-body',
  });
  card.appendChild(cardBody);

  const title = createElement({
    classes: 'd-flex justify-content-between',
  });
  cardBody.appendChild(title);

  const h4 = createElement({
    element: 'h4',
    classes: 'heading-4',
  });
  title.appendChild(h4);

  const onBtnClick = (e) => {
    const collectionName = e.currentTarget.getAttribute('data-collection-title');
    AddToMyBoards.openModal(ContentItemTypes.collection, null, null, collectionName);
  };

  const addToBoardBtn = createElement({
    element: 'button',
    classes: 'btn save-board-btn text-size-normal align-self-start py-0',
    attributes: {
      'data-collection-title': name,
    },
    eventListeners: {
      click: onBtnClick,
    },
    children: [
      createElement({
        element: 'i',
        classes: 'far fa-heart',
      }),
    ],
  });
  title.appendChild(addToBoardBtn);

  const aTitle = createElement({
    element: 'a',
    classes: 'title',
    attributes: { href: path },
    text: name,
  });
  h4.appendChild(aTitle);


  const row = createElement({
    classes: 'row',
  });
  cardBody.appendChild(row);

  const col = createElement({
    classes: 'col-12 col-md-11',
  });
  row.appendChild(col);

  const productTypesContainer = createElement({
    classes: 'row no-gutters text-size-small',
  });
  col.appendChild(productTypesContainer);

  productGroups.forEach((productGroup) => {
    const { ProductGroupLabel } = productGroup;

    const div = createElement({
      classes: 'col-12 col-md-6',
    });
    productTypesContainer.appendChild(div);

    const amount = createElement({
      element: 'span',
      classes: 'medium',
      text: `${productGroup.Products.length} `,
    });
    div.appendChild(amount);

    const type = createElement({
      element: 'span',
      text: ProductGroupLabel,
    });
    div.appendChild(type);
  });


  return card;
};


const Compare = {
  dateDesc(prod1, prod2) {
    const date1 = new Date(prod1.state.IntroductionDate).getTime();
    const date2 = new Date(prod2.state.IntroductionDate).getTime();
    return date2 - date1;
  },

  alphabetic(col1, col2) {
    const name1 = col1.state.CollectionName.trim().toLowerCase();
    const name2 = col2.state.CollectionName.trim().toLowerCase();
    return name1.localeCompare(name2);
  },

  sort(sortFunc) {
    const { filteredCollections, collections, searchResults } = Page.state;

    filteredCollections.sort(sortFunc);
    collections.sort(sortFunc);
    searchResults.sort(sortFunc);

    Page.setState({
      filteredCollections,
      collections,
      searchResults,
    });
  },
};


Page.onInit();
